module.exports = __webpack_public_path__ + "assets/img/cup.0987298877fea287ae9602ebd0492006.svg";